import React, { Component } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import logo from '../src/logo/logo.jpeg'
import { Button } from "@mui/material";
import AccountCircle from '@mui/icons-material/AccountCircle';
 

export class AppHeader extends Component {
  render() {
    return (
      <Box sx={{width:'100%'}}>
      <AppBar position="fixed" sx={{backgroundColor:'#fff'}}>
        <Toolbar variant="dense" sx={{display:'flex',justifyContent:'space-between',flexDirection:'row'}}>
          <img src={logo} style={{height:40,width:80}}/>

          <Box sx={{display:'flex',flexDirection:'row'}}>
              
          <Button variant="contained" onClick={()=>window.open('https://vendor.ekbsapp.com/')} size="small" sx={{fontSize:11,borderRadius:4,mr:1,display:{xs:'none',sm:'block',md:'block'}}}>Vendor Login</Button>
          <Button variant="outlined"  onClick={()=>window.open('/apply_vendor_registration')}  size="small" sx={{fontSize:11,borderRadius:4, borderColor:'grey', display:{xs:'none',sm:'block',md:'block'}}}>Vender Registration</Button>

                   <Button variant="contained" onClick={()=>window.open('https://vendor.ekbsapp.com/')} size="small" sx={{fontSize:11,mr:1,borderRadius:4,display:{xs:'block',sm:'none',md:'none'}}}>Login</Button>
          <Button variant="outlined"  onClick={()=>window.open('/apply_vendor_registration')}  size="small" sx={{fontSize:11,borderRadius:4, borderColor:'grey', display:{xs:'block',sm:'none',md:'none'}}}>Registration</Button>


          </Box>


        </Toolbar>
      </AppBar>
      </Box>
    );
  }
}

export default AppHeader;
